/* import __COLOCATED_TEMPLATE__ from './follow-guidance.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    accordion: $TSFixMe;
    guidelinesCount: number;
  };
}

const FollowGuidance = templateOnlyComponent<Signature>();
export default FollowGuidance;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::ConversationFlowSections::FollowGuidance': typeof FollowGuidance;
    'workflows/graph-editor/node-items/steps/fin/conversation-flow-sections/follow-guidance': typeof FollowGuidance;
  }
}
